import React, { useState } from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { usePublicSiteBranding, usePublicSiteId } from '../../contexts/PublicSiteContext';
import type { PublicSiteId } from '../../utils/publicSite';

interface PricingFeature {
  content: string;
}

const storageWalkFeatures: PricingFeature[] = [
    { content: "GPS tracking with Daily Site Walks" },
    { content: "Reports sent to manager's computer" },
    { content: "Back up reports sent to the cloud" },
    { content: "Camera functions to take pictures of potential issues on site" },
    { content: "Be able to keep track of multiple sites" },
    { content: "Task management for employees" },
    { content: "Note taking functions for record keeping" },
    { content: "Ensures completed daily site inspections" },
    { content: "Pinpoints specific time frames when storage units may have been breached"},
    { content: "Provides an additional level of security for customer's valuables"}
]

const patrolWalkFeatures: PricingFeature[] = [
    { content: "GPS tracking with verified patrol rounds" },
    { content: "Real-time reports sent to operations" },
    { content: "Secure cloud backup of all patrol data" },
    { content: "Photo documentation of incidents and checkpoints" },
    { content: "Multi-site patrol management" },
    { content: "Task assignment for patrol officers" },
    { content: "Detailed notes and observation logging" },
    { content: "Ensures completed patrol rounds on schedule" },
    { content: "Timestamps prove when and where patrols occurred" },
    { content: "Provides accountability and transparency for clients" }
]

const constructionWalkFeatures: PricingFeature[] = [
    { content: "Clock in on an authorized job and cost code, with geofence evidence" },
    { content: "Crew time, cost-code moves, and documented corrections" },
    { content: "Supervisor daily field report (weather, people, meetings, equipment, notes)" },
    { content: "Structured job walks with required checkpoint photos" },
    { content: "Approved hours posted to Sage 100 Contractor or QuickBooks Online, no retyping" },
    { content: "Exception queue for payroll instead of reviewing every card" }
]

function getPricingFeatures(siteId: PublicSiteId): PricingFeature[] {
  switch (siteId) {
    case 'security-walk':
      return patrolWalkFeatures
    case 'construction-walk':
      return constructionWalkFeatures
    default:
      return storageWalkFeatures
  }
}

const PricingPlan = ({pricing}: any) => {
  const [showPopup, setShowPopup] = useState(false);
  const siteId = usePublicSiteId();
  const branding = usePublicSiteBranding();
  const features = getPricingFeatures(siteId);

  const handleEmailClick = () => {
    setShowPopup(true);
  }

  const handleClosePopup = () => {
    setShowPopup(false);
  }
  
  return (
    <div ref={pricing} className="w-full mx-auto py-20 px-6" style={{backgroundColor: "white"}}>
        <div className="flex flex-col items-center">
            <div className="flex w-3/4 flex-col">
                <div className="text-2xl lg:text-3xl text-black font-bold">
                    Contact us for Pricing
                </div>
                <hr className="h-px my-8 border-0 bg-marketing-rule"></hr>
                    <ul className="flex flex-row flex-wrap justify-between">
                        {features.map((item, index) => (
                            <li key={index} className="flex md:text-sm w-1/2 p-4 items-center xs:text-xs text-black">
                                <CheckCircleIcon fontSize="small" className="mr-2 text-marketing-accent"/>
                                {item.content}
                            </li>
                        ))}
                    </ul>
                <hr className="h-px my-8 border-0 bg-marketing-rule"></hr>
            </div>
            <button onClick={handleEmailClick} className="bg-marketing-accent py-3 px-12 my-10 text-white rounded-md font-bold hover:opacity-95">
              Get Started Today
          </button>
          {showPopup && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50" onClick={handleClosePopup}>
            <div className="bg-white p-6 rounded-md shadow-lg xs:w-3/4 md:w-1/2" onClick={(e) => e.stopPropagation()}>
              <p className="text-center">
                Email us at{' '}
                <a href={`mailto:${branding.pricingContactEmail}`} className="text-blue-600 hover:underline">
                  {branding.pricingContactEmail}
                </a>{' '}
                for more information
              </p>
            </div>
          </div>
          )}
        </div>
    </div>
  )
}

export default PricingPlan
